import {create} from 'zustand';
import {type FaceLandmarksDetector} from '@tensorflow-models/face-landmarks-detection';

interface FaceModelsState {
  isLoading: boolean;
  isWebGLSupported: boolean;
  detector: FaceLandmarksDetector | null;
  hasFailed: boolean;
}

interface FaceModelsStore extends FaceModelsState {
  setIsLoading: (value: boolean) => void;
  setIsWebGLSupported: (value: boolean) => void;
  setDetector: (value: FaceLandmarksDetector | null) => void;
  setHasFailed: (value: boolean) => void;
}

const INITIAL_STATE: FaceModelsState = {
  isLoading: false,
  isWebGLSupported: false,
  detector: null,
  hasFailed: false,
};

export const useFaceModelsStore = create<FaceModelsStore>(set => ({
  ...INITIAL_STATE,

  setIsLoading: isLoading => set({isLoading}),

  setDetector: detector => set({detector}),

  setIsWebGLSupported: isWebGLSupported => set({isWebGLSupported}),

  setHasFailed: hasFailed => set({hasFailed}),
}));
